<mat-form-field fxFlex="0 0 100%" appearance="outline" [formGroup]="frmGroup" color="accent">
  <mat-label>{{ configData.label }}</mat-label>
  <input 
    matInput 
    autocomplete="off"
    [matDatepicker]="picker"
    [formControlName]="configData.name"
    [placeholder]="configData.placeHolder"
    [required]="configData.required"
    [min] = "getControlMinDate()"
    class="date-picker"
    name="{{configData.name}}"
    (dateChange)="compareTwoDates($event)" 
    [max] = "getControlMaxDate()"
  >       
  <mat-error *ngIf="frmGroup.get(configData.name).errors">
    <!-- {{frmGroup.get(configData.name).errors | json}} -->
    <mat-error *ngIf="(frmGroup.get(configData.name).errors | firstError) === 'required' ">Required</mat-error>  
    <mat-error *ngIf="(frmGroup.get(configData.name).errors | firstError) === 'fromInsertDate' ">From Date can't before To date</mat-error>
    <mat-error *ngIf="(frmGroup.get(configData.name).errors | firstError) === 'toInsertDate' ">To Date can't before From date</mat-error>
    <mat-error *ngIf="(frmGroup.get(configData.name).errors | firstError) === 'lateDeliveryDate' ">Delivery Date can't before Pickup date</mat-error>
    <mat-error *ngIf="(frmGroup.get(configData.name).errors | firstError) === 'earlyPickupDate' ">Pickup Date can't later Delivery date</mat-error>  
    <mat-error *ngIf="(frmGroup.get(configData.name).errors | firstError) === 'earlyDeliveryDate' ">Delivery Date can't before Pickup date</mat-error>
    <mat-error *ngIf="(frmGroup.get(configData.name).errors | firstError) === 'latePickupDate' ">Pickup Date can't later Delivery date</mat-error>  
    <mat-error *ngIf="(frmGroup.get(configData.name).errors | firstError) === 'matDatepickerMin' ">Previous date is not allowed</mat-error>  
    <mat-error *ngIf="(frmGroup.get(configData.name).errors | firstError) === 'matDatepickerMax' ">Pickup Date can't later Delivery date</mat-error>
</mat-error>

  <!-- [value]="date.value" -->
  <mat-icon matSuffix (click)="picker.open()" class="picker-toggle">today</mat-icon>
  <!--mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle-->
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
